<section class="sitemap-container page-section">
    <div class="title">
        <h1>FreeUp Mobile Sitemap</h1>
    </div>
    <div class="container-flex-row sitemap-sections">
        <div class=" sitemap-section">
            <div class="section-title">
                <h3>Shop</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a [routerLink]="[SHOP_ROUTE_URLS.BASE+'/'+SHOP_ROUTE_URLS.PLANS_AND_FEATURES+'/'+PLANS_SHOP_ROUTE_URLS.NEW_PLAN]">Cell
                            phone plans</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INTERNATIONAL_CALLING]">International
                            calling</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INTERNATIONAL_SMS]">International
                            sms</a></li>
                </ul>
            </div>
        </div>
        <div class="sitemap-section">
            <div class="section-title">
                <h3>Account</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a [routerLink]="[ACCOUNT_ROUTE_URLS.BASE+'/'+ACCOUNT_ROUTE_URLS.SUMMARY]">Account summary</a>
                    </li>
                    <li><a [routerLink]="[ACCOUNT_ROUTE_URLS.BASE+'/'+ACCOUNT_ROUTE_URLS.PAY_AND_RENEW]">Pay & refill
                            your account</a></li>
                    <li><a [routerLink]=" [ACCOUNT_ROUTE_URLS.BASE+'/'+ACCOUNT_ROUTE_URLS.PAYMENTS]">Payment history</a>
                    </li>
                    <li><a [routerLink]=" [ACCOUNT_ROUTE_URLS.BASE+'/'+ACCOUNT_ROUTE_URLS.USAGE]">Usage</a></li>
                    <li><a [routerLink]=" [ACCOUNT_ROUTE_URLS.BASE+'/'+ACCOUNT_ROUTE_URLS.MANAGE_DEVICES]">Manage
                            devices</a></li>
                    <li><a [routerLink]=" [ACCOUNT_ROUTE_URLS.BASE+'/'+ACCOUNT_ROUTE_URLS.SETTINGS]">Profile
                            settings</a></li>
                </ul>
            </div>
        </div>
        <div class=" sitemap-section">
            <div class="section-title">
                <h3>Support</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.DEALERS]">Dealers</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.FAQS]">FAQs</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.CONTACT_US]">Contact us</a>
                    </li>
                    <li><a [routerLink]="[ACTIVATION_ROUTE_URLS.BASE+'/'+ACTIVATION_ROUTE_URLS.SIM_CHECK]">Activate</a>
                    </li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.LANDING_COVERAGE]">Coverage</a>
                    </li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SHOP_ROUTE_URLS.CHECK_PHONE]">Check
                            compatibility</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.DATA_SETUP]">Setup your phone
                            data</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.SWITCH_AND_SAVE]">Switch and
                            save</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.HEARING_AID_COMPATIBILITY]">Hearing
                            aid compatibility</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.HD_VOICE]">HD Voice</a></li>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.WIFI_CALLING]">Wifi Calling</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="sitemap-section">
            <div class="section-title">
                <h3>Terms & Conditions</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS]">Terms
                            and conditions</a></li>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS+'/'+TERMS_AND_CONDITIONS_ROUTE_URLS.TERMS_OF_USE]">Terms
                            of use</a></li>
                </ul>
            </div>
        </div>
        <div class=" sitemap-section">
            <div class="section-title">
                <h3>Intl. Calling Terms & Conditions</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INT_CALLING_TERMS_AND_CONDITIONS+'/'+INT_CALLING_TERMS_AND_CONDITIONS_ROUTE_URLS.INT_CALLING_TERMS_OF_USE]">International
                            Calling Terms of Use</a></li>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INT_CALLING_TERMS_AND_CONDITIONS+'/'+INT_CALLING_TERMS_AND_CONDITIONS_ROUTE_URLS.INT_CALLING_PRIVACY_POLICY]">Privacy
                            policy</a></li>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.INT_CALLING_TERMS_AND_CONDITIONS+'/'+INT_CALLING_TERMS_AND_CONDITIONS_ROUTE_URLS.INT_CALLING_EULA]">EULA</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sitemap-section">
            <div class="section-title">
                <h3>Privacy Policy</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS+'/'+TERMS_AND_CONDITIONS_ROUTE_URLS.PRIVACY_NOTICE]">Privacy
                            notice</a></li>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS+'/'+TERMS_AND_CONDITIONS_ROUTE_URLS.MOBILE_BROADBAND]">Mobile
                            broadband consumer disclosure</a></li>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS+'/'+TERMS_AND_CONDITIONS_ROUTE_URLS.UNLOCK_PRIVACY]">Unlocking
                            policy</a></li>
                    <li><a
                            [routerLink]="[SUPPORT_ROUTE_URLS.BASE+'/'+SUPPORT_ROUTE_URLS.TERMS_AND_CONDITIONS+'/'+TERMS_AND_CONDITIONS_ROUTE_URLS.OPEN_INTERNET]">Open
                            Internet & broadband information</a></li>
                </ul>
            </div>
        </div>
        <div class="sitemap-section">
            <div class="section-title">
                <h3>BYOD</h3>
            </div>
            <div class="section-list">
                <ul>
                    <li><a [routerLink]="['/'+ROUTE_URLS.BRING_PHONE]">Bring your phone</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>